export var CollectionType;
(function (CollectionType) {
    /** User-created collection. */
    CollectionType["NATIVE"] = "NATIVE";
    /** [Collection](https://support.wix.com/en/article/velo-working-with-wix-app-collections-and-code#what-are-wix-app-collections) created by a Wix app when it is installed. This type of collection can be modified dynamically by that app (for example, Wix Forms). */
    CollectionType["WIX_APP"] = "WIX_APP";
    /** Collection created by a Wix Blocks app. */
    CollectionType["BLOCKS_APP"] = "BLOCKS_APP";
    /** Collection located in externally connected storage. */
    CollectionType["EXTERNAL"] = "EXTERNAL";
})(CollectionType || (CollectionType = {}));
export var Direction;
(function (Direction) {
    Direction["ASC"] = "ASC";
    Direction["DESC"] = "DESC";
})(Direction || (Direction = {}));
export var DataOperation;
(function (DataOperation) {
    DataOperation["AGGREGATE"] = "AGGREGATE";
    DataOperation["BULK_INSERT"] = "BULK_INSERT";
    DataOperation["BULK_REMOVE"] = "BULK_REMOVE";
    DataOperation["BULK_SAVE"] = "BULK_SAVE";
    DataOperation["BULK_UPDATE"] = "BULK_UPDATE";
    DataOperation["COUNT"] = "COUNT";
    DataOperation["DISTINCT"] = "DISTINCT";
    DataOperation["FIND"] = "FIND";
    DataOperation["GET"] = "GET";
    DataOperation["INSERT"] = "INSERT";
    DataOperation["INSERT_REFERENCE"] = "INSERT_REFERENCE";
    DataOperation["IS_REFERENCED"] = "IS_REFERENCED";
    DataOperation["QUERY_REFERENCED"] = "QUERY_REFERENCED";
    DataOperation["REMOVE"] = "REMOVE";
    DataOperation["REMOVE_REFERENCE"] = "REMOVE_REFERENCE";
    DataOperation["REPLACE_REFERENCES"] = "REPLACE_REFERENCES";
    DataOperation["SAVE"] = "SAVE";
    DataOperation["TRUNCATE"] = "TRUNCATE";
    DataOperation["UPDATE"] = "UPDATE";
    DataOperation["PATCH"] = "PATCH";
    DataOperation["BULK_PATCH"] = "BULK_PATCH";
})(DataOperation || (DataOperation = {}));
export var CollectionOperation;
(function (CollectionOperation) {
    /** Supports updating this collection. */
    CollectionOperation["UPDATE"] = "UPDATE";
    /** Supports removing this collections. */
    CollectionOperation["REMOVE"] = "REMOVE";
})(CollectionOperation || (CollectionOperation = {}));
export var FieldType;
(function (FieldType) {
    FieldType["UNKNOWN_FIELD_TYPE"] = "UNKNOWN_FIELD_TYPE";
    FieldType["TEXT"] = "TEXT";
    FieldType["NUMBER"] = "NUMBER";
    FieldType["DATE"] = "DATE";
    FieldType["DATETIME"] = "DATETIME";
    FieldType["IMAGE"] = "IMAGE";
    FieldType["BOOLEAN"] = "BOOLEAN";
    FieldType["DOCUMENT"] = "DOCUMENT";
    FieldType["URL"] = "URL";
    FieldType["RICH_TEXT"] = "RICH_TEXT";
    FieldType["VIDEO"] = "VIDEO";
    FieldType["ANY"] = "ANY";
    FieldType["ARRAY_STRING"] = "ARRAY_STRING";
    FieldType["ARRAY_DOCUMENT"] = "ARRAY_DOCUMENT";
    FieldType["AUDIO"] = "AUDIO";
    FieldType["TIME"] = "TIME";
    FieldType["LANGUAGE"] = "LANGUAGE";
    FieldType["RICH_CONTENT"] = "RICH_CONTENT";
    FieldType["MEDIA_GALLERY"] = "MEDIA_GALLERY";
    FieldType["ADDRESS"] = "ADDRESS";
    FieldType["PAGE_LINK"] = "PAGE_LINK";
    FieldType["REFERENCE"] = "REFERENCE";
    FieldType["MULTI_REFERENCE"] = "MULTI_REFERENCE";
    FieldType["OBJECT"] = "OBJECT";
    FieldType["ARRAY"] = "ARRAY";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    FieldType["LEGACY_TIME"] = "LEGACY_TIME";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    FieldType["LEGACY_BOOK"] = "LEGACY_BOOK";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    FieldType["LEGACY_EXTERNAL_URL"] = "LEGACY_EXTERNAL_URL";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    FieldType["LEGACY_BROKEN_REFERENCE"] = "LEGACY_BROKEN_REFERENCE";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    FieldType["LEGACY_IMAGE"] = "LEGACY_IMAGE";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    FieldType["LEGACY_COLOR"] = "LEGACY_COLOR";
    /** Deprecated - can’t be added to collections. Can only appear in older collections. */
    FieldType["LEGACY_EXTERNAL_VIDEO"] = "LEGACY_EXTERNAL_VIDEO";
})(FieldType || (FieldType = {}));
export var QueryOperator;
(function (QueryOperator) {
    QueryOperator["EQ"] = "EQ";
    QueryOperator["LT"] = "LT";
    QueryOperator["GT"] = "GT";
    QueryOperator["NE"] = "NE";
    QueryOperator["LTE"] = "LTE";
    QueryOperator["GTE"] = "GTE";
    QueryOperator["STARTS_WITH"] = "STARTS_WITH";
    QueryOperator["ENDS_WITH"] = "ENDS_WITH";
    QueryOperator["CONTAINS"] = "CONTAINS";
    QueryOperator["HAS_SOME"] = "HAS_SOME";
    QueryOperator["HAS_ALL"] = "HAS_ALL";
    QueryOperator["EXISTS"] = "EXISTS";
    QueryOperator["URLIZED"] = "URLIZED";
})(QueryOperator || (QueryOperator = {}));
export var FieldPluginType;
(function (FieldPluginType) {
    FieldPluginType["UNKNOWN"] = "UNKNOWN";
    /** CMS-related field attributes */
    FieldPluginType["CMS"] = "CMS";
})(FieldPluginType || (FieldPluginType = {}));
export var Role;
(function (Role) {
    /** Unknown. */
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    /** Site administrator. */
    Role["ADMIN"] = "ADMIN";
    /** Signed-in user who added content to this collection. */
    Role["SITE_MEMBER_AUTHOR"] = "SITE_MEMBER_AUTHOR";
    /** Any signed-in user. */
    Role["SITE_MEMBER"] = "SITE_MEMBER";
    /** Any site visitor. */
    Role["ANYONE"] = "ANYONE";
})(Role || (Role = {}));
export var Status;
(function (Status) {
    Status["UNKNOWN_PUBLISH_PLUGIN_STATUS"] = "UNKNOWN_PUBLISH_PLUGIN_STATUS";
    Status["PUBLISHED"] = "PUBLISHED";
    Status["DRAFT"] = "DRAFT";
})(Status || (Status = {}));
export var Format;
(function (Format) {
    Format["UNKNOWN_URLIZED_PLUGIN_FORMAT"] = "UNKNOWN_URLIZED_PLUGIN_FORMAT";
    Format["ORIGINAL"] = "ORIGINAL";
    Format["PLAIN"] = "PLAIN";
})(Format || (Format = {}));
export var Type;
(function (Type) {
    /** Unknown plugin type. */
    Type["UNKNOWN_PLUGIN_TYPE"] = "UNKNOWN_PLUGIN_TYPE";
    /** Allows items to be marked as either draft or published. For each item you can set a publishing time when the item will become visible to site visitors. */
    Type["PUBLISH"] = "PUBLISH";
    /** Ensures the collection can have one item at most. Can only be applied to a new collection. */
    Type["SINGLE_ITEM"] = "SINGLE_ITEM";
    /** Generates item URLs for collections used by dynamic pages. */
    Type["URLIZED"] = "URLIZED";
    /** Deprecated. Will be removed in the future. */
    Type["GRIDAPPLESS"] = "GRIDAPPLESS";
    /** Indicates that the collection is translatable. This allows you to manage translation for selected fields using [Wix Multilingual](https://www.wix.com/app-market/wix-multilingual). */
    Type["MULTILINGUAL"] = "MULTILINGUAL";
    /** Indicates that collection is shared with current site */
    Type["SHARED"] = "SHARED";
    /** Indicates that page link fields are persisted and can be updated */
    Type["EDITABLE_PAGE_LINK"] = "EDITABLE_PAGE_LINK";
    /** CMS-specific collection properties */
    Type["CMS"] = "CMS";
})(Type || (Type = {}));
export var PagingMode;
(function (PagingMode) {
    /** Offset-based paging. */
    PagingMode["OFFSET"] = "OFFSET";
    /** Cursor-based paging. */
    PagingMode["CURSOR"] = "CURSOR";
})(PagingMode || (PagingMode = {}));
/**
 * Describes who can perform certain action.
 * Each level includes all levels below it (except UNDEFINED).
 */
export var AccessLevel;
(function (AccessLevel) {
    /** Not set */
    AccessLevel["UNDEFINED"] = "UNDEFINED";
    /** Any subject, including visitors */
    AccessLevel["ANYONE"] = "ANYONE";
    /** Any signed-in user (both site members and collaborators) */
    AccessLevel["SITE_MEMBER"] = "SITE_MEMBER";
    /** Any signed-in user, but site members only have access to own items */
    AccessLevel["SITE_MEMBER_AUTHOR"] = "SITE_MEMBER_AUTHOR";
    /** Site collaborator that has a role with CMS Access permission */
    AccessLevel["CMS_EDITOR"] = "CMS_EDITOR";
    /** CMS administrators and users or roles granted with special access */
    AccessLevel["PRIVILEGED"] = "PRIVILEGED";
})(AccessLevel || (AccessLevel = {}));
export var Segment;
(function (Segment) {
    Segment["UNKNOWN_SEGMENT"] = "UNKNOWN_SEGMENT";
    Segment["PUBLIC"] = "PUBLIC";
    Segment["DEV"] = "DEV";
})(Segment || (Segment = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
/**
 * Order determines how values are ordered in the index. This is important when
 * ordering and/or range querying by indexed fields.
 */
export var Order;
(function (Order) {
    Order["ASC"] = "ASC";
    Order["DESC"] = "DESC";
})(Order || (Order = {}));
export var IndexStatus;
(function (IndexStatus) {
    /** Place holder. Never returned by the service. */
    IndexStatus["UNKNOWN"] = "UNKNOWN";
    /** Index creation is in progress. */
    IndexStatus["BUILDING"] = "BUILDING";
    /** Index has been successfully created and can be used in queries. */
    IndexStatus["ACTIVE"] = "ACTIVE";
    /** Index is in the process of being dropped. */
    IndexStatus["DROPPING"] = "DROPPING";
    /** Index has been dropped successfully. */
    IndexStatus["DROPPED"] = "DROPPED";
    /** Index creation has failed. */
    IndexStatus["FAILED"] = "FAILED";
    /** Index contains incorrectly indexed data. */
    IndexStatus["INVALID"] = "INVALID";
})(IndexStatus || (IndexStatus = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map